export default __webpack_public_path__ + "static/media/802_06-18-2022_Jennifer+Jack_Wedding.7675b3e0.jpg";